import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { validations } from "../Validations/regexValidations";

export default function DirectoresForm() {
  const emptyFieldErrorMessage = "Campo obligatorio";
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const { append, fields, prepend } = useFieldArray({
    control,
    name: "directors",
  });
  useEffect(() => {
    !fields.length && prepend({});
  }, []);
  return (
    <React.Fragment>
      {fields.map((field, index) => {
        const baseName = `directors[${index}]`;
        return (
				<div key={field.id} className="mb-6 create__requisitos">
					<h4 className="create__requisitos-title">Directores</h4>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label" htmlFor="">
								Nombres y apellidos
							</label>
							<input
								type="text"
								maxLength={60}
								className="global-input"
								placeholder="Nombres y apellidos"
								{...register(`${baseName}.Names`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Names`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label" htmlFor="">
								% de participación
							</label>
							<input
								type="text"
								maxLength={3}
								className="global-input"
								placeholder="0%"
								{...register(`${baseName}.ParticipationPercentage`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.numerosYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.ParticipationPercentage`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2 lg:pr-4">
							<label className="global-label" htmlFor="">
								No. de identificación
							</label>
							<input
								type="text"
								maxLength={11}
								className="global-input"
								placeholder="No. de identificación"
								{...register(`${baseName}.IdNo`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasNumerosEspacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.IdNo`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
				</div>
			);
      })}
      <div className="mt-6 mb-6 text-center create__requisitos">
        <button
          type="button"
          onClick={() => {
            append({});
          }}
          className="mb-4"
        >
          <div className="mx-auto text-[#012169] opacity-50 text-[40px]">+</div>
          <span className="text-[#012169] opacity-50 font-bold mb-3">
            Agregar otro director
          </span>
        </button>
      </div>
    </React.Fragment>
  );
}
